import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { Tab, Tabs, Typography } from '@mui/material';

const FlexBox = styled(Box)({
  display: 'flex',
});

const ColumnFlexBox = styled(FlexBox)({
  flexDirection: 'column',
});

const AlignedFlexBox = styled(FlexBox)({
  alignItems: 'center',
});

const CenteredFlexBox = styled(FlexBox)({
  alignItems: 'center',
  justifyContent: 'center',
});

const AlignedBetweenFlexBox = styled(AlignedFlexBox)({
  justifyContent: 'space-between',
});

const FullSizeCenteredFlexBox = styled(CenteredFlexBox)({
  width: '100%',
  height: '100%',
});

// typography styles
const Typography28500 = styled(Typography)({
  fontSize: '28px',
  fontWeight: 500,
});

const TypographyMedium = styled(Typography)({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '120%',
});

const TypographyMediumSm = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '120%',
});

const TypographyMediumSmBold = styled(TypographyMediumSm)({
  fontWeight: 500,
});

const TypographySmall = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '120%',
  color: theme.customColors.black50,
}));

// custom components
const CustomVerticalDivider = styled(Box)(({ theme }) => ({
  width: '1px',
  height: '100%',
  backgroundColor: theme.customColors.black10,
}));

const CustomHorizontalDivider = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '1px',
  backgroundColor: theme.customColors.black10,
}));

const DetailsCard = styled(ColumnFlexBox)(({ theme }) => ({
  borderRadius: 12,
  gap: theme.spacing(6),
  padding: theme.spacing(8, 7),
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.customShadows.smallDetailsShadow,
}));

const InputForm = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    color: theme.palette.text.primary, // Text color
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.primary, // Label color

    '&.Mui-focused': {
      color: theme.palette.text.primary, // Focused label color
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.customColors.black10, // Default border color
    },
    '&:hover fieldset': {
      borderColor: theme.customColors.primary700, // Hover border color
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.customColors.primary700, // Focused border color
    },
  },
}));

const DataGridStyled = styled(DataGrid)(({ theme }) => ({
  width: '100%',
  cursor: 'pointer',
  padding: theme.spacing(1),
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,

  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.background.paper,
  },

  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },

  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
}));

// const TabsStyled = styled(Tabs)(({ theme }) => ({
//   borderBottom: `1px solid ${theme.customColors.black10}`,

//   '& .MuiTab-root': {
//     textTransform: 'none',
//     fontSize: '18px',
//     fontWeight: 400,
//     lineHeight: '120%',
//     color: theme.customColors.black30,
//   },

//   '& .Mui-selected': {
//     color: theme.customColors.black,
//   },

//   '& .MuiButtonBase-root': {
//     padding: 0,
//     minWidth: 'auto',
//     width: 'fit-content',
//     alignItems: 'flex-start',
//   },

//   '& .MuiTabs-flexContainer': {
//     gap: '40px',
//     display: 'flex',
//   },

//   '& .MuiTabs-indicator': {
//     backgroundColor: theme.customColors.primary100,
//   },
// }));

export const TabsStyled = styled(Tabs)(({ theme }) => ({
  minHeight: 'auto',
  borderBottom: `1px solid ${theme.customColors.black10}`,

  '& .MuiTab-root': {
    textTransform: 'none',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '120%',
    color: theme.customColors.black30,
  },

  '& .Mui-selected': {
    fontWeight: 500,
    color: theme.customColors.black + '!important',
  },

  '& .MuiButtonBase-root': {
    padding: 0,
    minHeight: 'auto',
    minWidth: 'auto',
    width: 'fit-content',
    alignItems: 'flex-start',
  },

  '& .MuiTabs-flexContainer': {
    gap: '40px',
    display: 'flex',
    // only if min-height auto
    marginBottom: theme.spacing(2),
  },

  '& .MuiTabs-indicator': {
    backgroundColor: theme.customColors.primary100,
  },
}));

export const TabItem = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  textDecoration: 'none',

  '&.Mui-selected': {
    fontWeight: 500,
    color: theme.customColors.black,
  },
}));

export {
  FlexBox,
  InputForm,
  ColumnFlexBox,
  AlignedFlexBox,
  DataGridStyled,
  CenteredFlexBox,
  Typography28500,
  TypographySmall,
  TypographyMedium,
  TypographyMediumSm,
  DetailsCard,
  CustomVerticalDivider,
  AlignedBetweenFlexBox,
  TypographyMediumSmBold,
  FullSizeCenteredFlexBox,
  CustomHorizontalDivider,
};
